import { FC, PropsWithChildren } from 'react'
import { QueryClientProvider } from 'react-query'

import { queryClient } from './query.client'

export const QueryProvider: FC<PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
